import { createFrontendModule } from '@backstage/frontend-plugin-api';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import { TechDocsIndexPageContent } from './TechDocsIndexPageContent';

// Upstream hardcodes the docs explorer's filters, so the page's content is
// replaced to add a System filter; path, title and icon are kept as-is.
const techdocsPageOverride = techdocsPlugin
  .getExtension('page:techdocs')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        params: {
          loader: async () => (
            <TechDocsIndexPageContent initialFilter={config.initialFilter} />
          ),
        },
      });
    },
  });

export const techdocsModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techdocsPageOverride],
});
